import { render, staticRenderFns } from "./BottomRole.vue?vue&type=template&id=5532d738&scoped=true&"
import script from "./BottomRole.vue?vue&type=script&lang=js&"
export * from "./BottomRole.vue?vue&type=script&lang=js&"
import style0 from "./BottomRole.vue?vue&type=style&index=0&id=5532d738&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5532d738",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VLazy})
